// lib/filters/parseKonosFileLink
var name = 'konos-file';
var link = 'konos-file';

function parseLink(name = null, parseLink = null) {
    return function (filename, number) {
        var link = parseLink + '/' + filename;
        var data = {};
        data.name = name;
        if (number) data.number = number.trim();
        if (number) data.filename = filename;
        data = JSON.stringify(data);
        return `<a data-data='${data}' href="${link}">Скачать документ</a>`
    }
}


export default {
    filters: {parseKonosFileLink: parseLink(name, link)}
}



/** WEBPACK FOOTER **
 ** ./src/js/lib/filters/parseKonosFileLink.js
 **/